export const BUSINESS_INFO = {
  companyName: "Thakkhar Realtors",
  registrationNumber: "TR-REG-2026-XXXX",
  gstNumber: "GSTIN Pending Update",
  officeAddressLine1: "Shop No. 26, Riddhi Complex",
  officeAddressLine2: "Sector 13, Khanda Colony",
  city: "New Panvel (W)",
  state: "Maharashtra",
  pinCode: "410206",
  businessEmail: "chirag.thakkar3259@gmail.com",
  secondaryEmail: "chirag.thakkar3259@gmail.com",
  phone: "+91 9979183259",
  emergencyPhone: "+91 9979183259",
  whatsappNumber: "919979183259",
  officeTimings: "Mon-Sat, 9:00 AM - 7:00 PM",
  mapEmbedUrl:
    "https://www.google.com/maps?q=Riddhi+Complex,+Sector+13,+Khanda+Colony,+New+Panvel+(W),+Maharashtra+410206&output=embed",
  mapDirectionUrl:
    "https://www.google.com/maps/place/Riddhi+Complex/@19.0057169,73.1108671,17z",
  yearsExperience: "10+",
  reraAuthority: "MahaRERA",
};

export const CHANNEL_PARTNER_DISCLOSURE =
  "This project is marketed by Thakkhar Realtors as an authorized channel partner. We are not the developer of this project. All project information has been provided by the developer and is subject to change.";

export const RERA_FALLBACK_TEXT =
  "RERA details will be updated upon official registration.";
